module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/113.db06e379.png";